<script setup lang="ts">
import type { LevelsWork, LevelsWorkData } from "~/layers/agents/types/LevelsWork";

const { section } = useThemeColor("dark");

const { find } = useStrapi();

const { data: levels_works } = await useAsyncData("levels-works", () =>
  find<LevelsWork>("levels-works", {
    populate: "*",
  }),
);

const getlevelsWork = computed<LevelsWorkData[]>(() => {
  return levels_works.value?.data?.map((item) => {
    return {
      ...item.attributes,
    };
  });
});
</script>

<template>
  <section v-if="getlevelsWork.length" ref="section" class="py-20 bg-white lg:pt-[120px]">
    <Container>
      <!-- <Text class="font-medium text-primary/60 mb-3" variant="12">Мы предлагаем</Text> -->
      <Heading class="leading-[100%] mb-10" as="h2" variant="4" text-transform="uppercase"
        >Программа развития сотрудничества</Heading
      >
      <InfoTabsHorizontal :tabs="getlevelsWork" />
    </Container>
  </section>
</template>

<style scoped></style>
